import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const IssueStatusStartedIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1m0 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11M8 4a4 4 0 0 1 0 8z"
			></path>
		</svg>
	),
)
